import { Card, CardBody, Col, Row } from 'reactstrap'
import { largeProgressData, largeProgressList } from '../../../../Data/Ui-Kits/Progress/Progress'
import { LargeProgressBars } from '../../../../Utils/Constants'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'
import { ProgressBar } from '../../../../AbstractElements'

const LargeProgressBarsCart = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CardHeaderCommon title={LargeProgressBars} span={largeProgressData} />
        <CardBody className="progress-showcase mb-3">
          <Row>
            <Col>
              <ProgressBar color="primary" value="25" className="lg-progress-bar">25%</ProgressBar>
              {largeProgressList.map(({ color, value, text }, index) => (
                <ProgressBar color={color} value={value} className="lg-progress-bar" key={index}>
                  {text}
                </ProgressBar>
              ))}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default LargeProgressBarsCart